import { render, staticRenderFns } from "./CompensationPoints.vue?vue&type=template&id=7700aa7c&scoped=true&"
import script from "./CompensationPoints.vue?vue&type=script&lang=js&"
export * from "./CompensationPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7700aa7c",
  null
  
)

export default component.exports